<template>
    <div class="app-design s_flex_bian">
      <div class="app-sider-left">
        <slot name="app-sider-left"></slot>
      </div>
      <div class="app-subject" id="app-subject">
      <div class="app-title-warp">
         <slot name='title'>
            <div class="app-title">
              <LeftOutlined class="fz-20 m-l-10" v-if="type!='mini'"/><span class="title fz-16">{{title}}</span>
              <img src="@/assets/images/scan/mini_bar.png" alt="" class="bar" v-if="type=='mini'">
           </div>
         </slot>
      </div>
        <div class="app-warp">
          <div class="app-content" @click="clickPage" :style="'background-color:'+color ">
            <slot name="app-content"></slot>
          </div>
        </div>
        <div class="app-extra">
          <slot name="app-extra"></slot>
        </div>
      </div>
      <div class="app-sider" >
        <slot name="app-sider"></slot>
      </div>
    </div>
</template>
<script>
import { LeftOutlined } from "@ant-design/icons-vue";
export default {
  name: "app-warp",
  components: { LeftOutlined },
  props: {
    title: String,
    color: String,
    padding: Boolean,
    type:{
      type:String,
      default:function(){
        return ''
      }
    }
  },
  setup(props, { emit }) {
    const clickPage = () => {
      emit("handleclick", 1);
    };
    return {
      clickPage
    };
  },
};
</script>
<style lang="less" scoped>
@import url("@/style/app-warp/app-warp.less");
</style>